<template>
	<div class="my-header flex">
		<!-- <div class="leftbtn1" :class="{isActiveStart:isActiveStart}" @click="startedCarousel()" v-show="seen"
			@mouseenter="enter">
			结束轮播</div>
		<div class="leftbtn" :class="{isActiveEnd:isActiveEnd}" @click="endCarousel()" v-show="seen"
			@mouseenter="enter">开始轮播
		</div> -->
		<div class="flex1 back" @mouseenter="enter" @mouseleave="leave">
			<slot name="HeaderLeft"></slot>
			<img @click="goBack" v-if="backFlag" class="clickBack" src="@/assets/images/photovoltaic/clickBack.png" alt="">
		</div>
		<img class="img flexs" :src="myHeader" alt="">
		<div class="flex1">
			<slot name="HeaderRight"></slot>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				isActiveStart: false,
				isActiveEnd: true,
				seen: false,
				myHeader: require('@/assets/images/photovoltaic/head.png'),
				backFlag: false
			}
		},
		// props:['isActiveEnd'],
		mounted() {
			// this.$EventBus.$on('clicktrue3', (show3) => {
			// 		if (show3) {
			// 			this.startedCarousel()
			// 		} 	
			// 	})  
			console.log(this.$route.fullPath,!this.$route.query,'哈哈哈哈哈哈哈')
			if(this.$route.fullPath != '/photovoltaicItem' || !this.$route.query){
				
				this.backFlag = true
			}
			
			  
			this.$EventBus.$on('clicktrue', (show1) => {
				console.log(show1, 'this.show1this.show1this.show2222222222222222222222')
				if (show1) {
					this.startedCarousel()
				}
			})
			this.$EventBus.$on('clicktrue2', (show2) => {
				console.log(show2, 'this.show1this.show1this.show2222222222222222222222')
				if (!show2) {
					this.endCarousel()
				}
			})
			// this.myHeader = require('@/assets/images/photovoltaic/head.png')
			// document.title = '协鑫数字能源智算和能源运营平台'
			// let { name } = this.$route
			// if(['chonghuan-home', 'chonghuan-monitor', 'chonghuan-station'].includes(name)) {
			//     this.myHeader = require('@/assets/images/myComm/header-1.png')
			//     document.title = '协鑫数字能源充换电一体化'
			// }
			// // 车算云
			// else if(['expositionRight'].includes(name)) {
			//     this.myHeader = require('@/assets/images/myComm/header-2.png')
			//     document.title = '协鑫数字能源光储充换车算云'
			// }
			// // 零碳交通
			// else if(['vehicles-home','heatmap-home','vehicletype-home','batterypack-home'].includes(name)) {
			//     this.myHeader = require('@/assets/images/myComm/header-3.png')
			//     document.title = '协鑫数字能源零碳交通'
			// }
			// // 虚拟电厂
			// else if(['dummy'].includes(name)) {
			//     this.myHeader = require('@/assets/images/myComm/header-4.png')
			//     document.title = '协鑫数字能源虚拟电厂VPP'
			// }       
		},
		methods: {
			enter() {
				this.seen = true;
			},
			leave() {
				this.seen = false;
			},
			startedCarousel() {
				this.isActiveStart = true;
				this.isActiveEnd = false;
				// this.isActiveStart = !this.isActiveStart; 
				// this.isActiveEnd = !this.isActiveEnd;
				this.$EventBus.$emit('isActiveEnd', this.isActiveEnd)
			},
			endCarousel() {
				this.isActiveStart = false;
				this.isActiveEnd = true;
				// this.isActiveStart = !this.isActiveStart; 
				// this.isActiveEnd = !this.isActiveEnd;
				this.$EventBus.$emit('isActiveEnd', this.isActiveEnd)
				// console.log('endCarouselthis.isActiveEnd:',this.isActiveEnd)
			},
			goBack(){
				this.$router.go(-1)
			}	
		}
	}
</script>

<style lang="scss" scoped>
	@import '@/assets/scss/comm.scss';


	.my-header {
		width: 100%;
		height: $HeaderHeight;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 100;
		// background: url('~@/assets/images/myComm/header-bg.png') no-repeat;
		background-size: 100%;

		.clickBack{
			width: 150.95px;
			height: 47px;
			margin: 40px 0 0 40px;
		}

		>div {
			position: relative;
		}

		>.img {
			width: 2700px;
			height: 150px;
			// position: absolute;
			// top: 50%;
			// left: 50%;
			// transform: translate(-50%, -50%);
		}

		.isActiveStart {
			display: none;
		}

		.isActiveEnd {
			display: none;
		}

		.leftbtn {
			-webkit-user-select: none;/* 禁止 DIV 中的文本被鼠标选中 */
			-moz-user-select: none;/* 禁止 DIV 中的文本被鼠标选中 */
			-ms-user-select: none;/* 禁止 DIV 中的文本被鼠标选中 */
			user-select: none;/* 禁止 DIV 中的文本被鼠标选中 */
			background: url('~@/assets/images/exposition/startedCarousel.png') no-repeat;
			background-size: 100%;
			position: absolute;
			width: 200px;
			height: 100px;
			top: 12px;
			left: 40px;
			text-align: center;
			font-size: 26px;
			line-height: 70px;
			font-family: "PMZD";
			z-index: 9999999999999999;
			cursor: default;
		}

		.leftbtn1 {
			-webkit-user-select: none;/* 禁止 DIV 中的文本被鼠标选中 */
			-moz-user-select: none;/* 禁止 DIV 中的文本被鼠标选中 */
			-ms-user-select: none;/* 禁止 DIV 中的文本被鼠标选中 */
			user-select: none;/* 禁止 DIV 中的文本被鼠标选中 */
			background: url('~@/assets/images/exposition/endCarousel.png') no-repeat;
			background-size: 100%;
			position: absolute;
			width: 200px;
			height: 100px;
			top: 12px;
			left: 40px;
			text-align: center;
			font-size: 26px;
			line-height: 73px;
			font-family: "PMZD";
			z-index: 9999999999999999;
			cursor: default;
		}

		.harbour-input {
			position: absolute;
			right: 180px;
			top: 20px;
			height: 20px;
			z-index: 6;

			.el-input__inner {
				background: rgba(74, 160, 176, 0.15);
				border: none;
				color: #ffffff;
			}
		}
	}
</style>

<style>
	.my-header .harbour-input .el-input__inner {
		background: rgba(74, 160, 176, 0.15);
		border: none;
		color: #ffffff;
	}
</style>